import React, { useEffect, useState } from "react";
import { Checkbox, Box, FormControlLabel, InputAdornment, Grid, Button, debounce } from "@mui/material";
import { CustomTextField, icon, IconComponent } from "../../../../../../common/components";
import { translate } from "../../../../../../common/providers";
import style from "./Filters.module.css";

const debounceFunc = debounce((func) => func(), 500);

export default function SearchModalContent({
	block,
	onGlobalUpdate,
	deleteSelection,
	pagination,
	onSearch,
	addActionFilter,
	showText,
}) {
	const { currentValue } = block.options;
	const testChecked = (item) => currentValue?.filter((v) => v.valueUuid === item.uuid)?.length > 0;
	const [textSearch, setTextSearch] = useState("");
	const [localTextValue, setLocalTextValue] = useState("");
	const [isFirstLoad, setIsFirstLoad] = useState(true);
	useEffect(() => {
		if (localTextValue?.length === 0 && isFirstLoad) {
			if (onSearch) {
				onSearch(localTextValue);
			} else {
				setTextSearch(localTextValue);
			}
			setIsFirstLoad(false);
		} else {
			debounceFunc(() => {
				if (onSearch) {
					onSearch(localTextValue);
				} else {
					setTextSearch(localTextValue);
				}
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [localTextValue, onSearch]);
	const handleSetLocalTextValue = (e) => {
		setLocalTextValue(e.target.value);
	};
	const handleGlobalUpdate = (e, item) => {
		onGlobalUpdate({
			uuid: block.id,
			value: item.name,
			valueUuid: item.uuid,
			checked: e.target.checked,
			type: block.type,
		});
	};
	return (
		<Box className={style.listSearchAccordion}>
			<Grid p={1}>
				<CustomTextField
					InputProps={{
						endAdornment: (
							<InputAdornment position="end">
								<IconComponent color="var(--grey-400)" icon={icon.faSearch} />
							</InputAdornment>
						),
					}}
					placeholder={translate("common:btn.search")}
					size="small"
					sx={{ width: "100%" }}
					value={localTextValue}
					variant="outlined"
					onChange={handleSetLocalTextValue}
				/>
				<Grid container alignItems="center" direction="row" justifyContent="flex-end" pt={1}>
					{addActionFilter}
					<Button
						className={style.clearButton}
						color="inherit"
						size="small"
						variant="warning"
						onClick={deleteSelection}
					>
						{translate("common:btn.clear-select")}
					</Button>
				</Grid>
			</Grid>
			{showText ? (
				<>{showText}</>
			) : (
				!isFirstLoad && (
					<Grid container className={style.accordionDetails}>
						{block?.options?.items
							?.filter?.((filter) =>
								textSearch !== "" ? filter.name.toLowerCase().includes(textSearch.toLowerCase()) : true
							)
							?.map((item) => (
								<Grid item md={12}>
									<FormControlLabel
										control={
											<Checkbox
												checked={testChecked(item)}
												onChange={(e) => {
													handleGlobalUpdate(e, item);
												}}
											/>
										}
										label={item?.name}
									/>
								</Grid>
							))}
					</Grid>
				)
			)}

			{pagination}
		</Box>
	);
}
